import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const allInOneChatApi = {
  getChatLog: (request) => {
    const { data } = request
    return instance().get(`/getchatlog`, { params: data })
  },
  getInboxThread: (request) => {
    const { data } = request
    return instance().post(`/api/cms/get-inbox-thread`, data)
  },
  postAdminRead: (request) => {
    const { data } = request
    return instance().post(`/api/cms/admin-read`, data)
  },
  getNotificationUnRead: () => {
    return instance().get(`/api/cms/inbox-noti-unread`)
  }
}

export default allInOneChatApi



// WEBPACK FOOTER //
// ./src/api/all-in-one-chat.js